<nz-spin [nzSpinning]="loading$ | async"
  ><div class="drawer-form-wrapper">
    <h3 class="title s-16 mb-16">
      {{ drawerParmas.selectedDay }},
      {{ drawerParmas.selectedDate | date: 'MMMM dd, yyyy' }}
    </h3>
    <form nz-form class="form" [formGroup]="frquencyIntervalForm">
      <div class="form-grid">
        <nz-form-item>
          <nz-form-label nzFor="type" nzRequired>Enter Frequency</nz-form-label>
          <nz-form-control>
            <input
              name="minutes"
              type="text"
              nz-input
              [mask]="'000'"
              [validation]="false"
              appAllowOnlyValidNumbers
              id="minutes"
              formControlName="frequency"
              placeholder="Enter frequency" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div
        class="ant-form-item-explain-error mt-3 mb-3"
        *ngIf="!frquencyIntervalForm.value.frequency">
        Please enter Frequency value.
      </div>
    </form>
    <p class="error-text mb-24">Enter numeric value for Frequency Only.</p>
    <div class="display-flex justify-content-between drawer-footer">
      <button nz-button type="button" nzType="default" (click)="onCancel()">
        Cancel
      </button>
      <div class="display-flex button-group-gap">
        <ng-container *ngIf="drawerParmas.selectedUnit !== 1">
          <button
            nz-button
            type="button"
            nzType="primary"
            (click)="submitForm()"
            [disabled]="!frquencyIntervalForm.value.frequency">
            Save & Close
          </button>
          <button
            *ngIf="hasNextDate"
            nz-button
            type="button"
            nzType="primary"
            (click)="submitAndNext()"
            [disabled]="!frquencyIntervalForm.value.frequency">
            Save & Next
          </button>
        </ng-container>
        <ng-container *ngIf="drawerParmas.selectedUnit === 1">
          <button
            nz-button
            type="button"
            nzType="primary"
            (click)="submitForm()"
            [disabled]="!frquencyIntervalForm.value.frequency">
            Save & Close
          </button>
          <button
            *ngIf="
              hasNextDateForUnit1 && (nextDateHasFrequency || nextDateHasNoData)
            "
            nz-button
            type="button"
            nzType="primary"
            (click)="continueWithFrequencyOnly()"
            [disabled]="!frquencyIntervalForm.value.frequency">
            Continue With Frequency
          </button>
          <button
            *ngIf="
              hasNextDateForUnit1 && (nextDateHasDuration || nextDateHasNoData)
            "
            nz-button
            type="button"
            nzType="primary"
            (click)="continueWithDuration()"
            [disabled]="!frquencyIntervalForm.value.frequency">
            Continue With Duration
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</nz-spin>
